<template>
  <div class="short-answer"
       ref="shortAnswer"
       id="shortAnswer"
       v-resize="this.resize">
    <div class="ui-layout-north border0 padding0"
         ref="defaultWidth"
         v-resize="this.resizeWest"
    >
      <div class="item-title pr">
        <div class="item-head-title">
          <span>资料区</span>
          <div class="pull-right">
            <button class="min-btn"
                    @click="toggleWin('top')"><i></i>{{ magnifyText }}
            </button>
          </div>
        </div>
        <div class="item-ques"
             :style="'width'+ defaultWidth"
             v-show="isShowLeft">
          <div class="content-stem">
            <span class="ques-num">{{ currentQuestion.showSerialNum }}</span>
            <span v-if="currentQuestion.additionalContent"
                  v-html="currentQuestion.additionalContent"></span>
          </div>
          <div v-if="quesContent" id="quesContentId" :class="{'has-requestList': currentQuestion.requestList && currentQuestion.requestList.length > 0 }"
               v-html="currentQuestion.content"></div>
          <!--资料题-->
          <template v-if="currentQuestion.requestList && currentQuestion.requestList.length>0">
            <ul class="anchor-list">
              <li v-for="(item,index) in currentQuestion.requestList"
                  :key="index"
                  :class="{ 'actived' : smallIndexQues === index}"
                  @click="anchorClick($event,index)">资料{{ sortArr[index] }}
              </li>
            </ul>
            <div id="quesContentId2" v-html="currentQuestion.requestList[smallIndexQues].requestContent"></div>
          </template>
        </div>
      </div>
    </div>
    <div class="ui-layout-center border0 padding0"
         ref="rightChildQuestion">
      <div class="item-title pr">
        <div class="item-head-title">
          <span>试题区</span>
          <div class="pull-right">
            <button class="min-btn"
                    @click="toggleWin('bottom')"><i></i>{{ magnifyText }}
            </button>
          </div>
        </div>
      </div>
      <div class="sa-input"
           ref="saInput"
           v-if="currentQuestion.smallContent[0].quesTypeID === 4 || currentQuestion.smallContent[0].quesTypeID === 5">
        <div class="clearfix"
             :style="'width'+ defaultRightWidth"
             >
          <div class="tab">
            <span v-for="(item,idx) in currentQuestion.smallContent"
                  @click="switchTabs($event,idx)"
                  :key="idx"
                  :class="{ 'actived' : smallIndex === idx}">要求{{ idx + 1 }}</span>
          </div>
          <div class="quesContent"
               ref="quesContent">
            <p class="sa-title">
              <span v-html="currentQuestion.smallContent[smallIndex].content"></span>
              <span>({{ currentQuestion.smallContent[smallIndex].score }}分)</span>
            </p>
            <div class="editor pr"
                 :ref="'editor'+currentQuestion.smallContent[smallIndex].questionID">
              <div class="sa-function clearfix">
                <ul>
                  <li>
                    <el-tooltip effect="dark"
                                content="复制"
                                placement="top">
                      <a href="javascript:void(0)"
                         @click="copyFn">
                        <img src="@/assets/images/formula/icon-copy.png"
                             alt="">
                      </a>
                    </el-tooltip>
                  </li>
                  <li>
                    <el-tooltip effect="dark"
                                content="剪切"
                                placement="top">
                      <a href="javascript:void(0)"
                         @click="cutFn">
                        <img src="@/assets/images/formula/icon-cut.png"
                             alt="">
                      </a>
                    </el-tooltip>
                  </li>
                  <li>
                    <el-tooltip effect="dark"
                                content="粘贴"
                                placement="top">
                      <a href="javascript:void(0)"
                         @click="pasteFn">
                        <img src="@/assets/images/formula/icon-paste.png"
                             alt="">
                      </a>
                    </el-tooltip>
                  </li>
                  <li>
                    <el-tooltip effect="dark"
                                content="插入公式符号"
                                placement="top">
                      <a href="javascript:void(0)"
                         @click="openFormula(smallIndex)">
                        <img src="@/assets/images/formula/icon-gs.png"
                             alt="">
                      </a>
                    </el-tooltip>
                    <formula :visible.sync="visibleFm[smallIndex]"
                             @toggleFn="insertWrite($event,smallIndex)"/>
                  </li>
                  <li>
                    <el-tooltip effect="dark"
                                content="插入表格矩阵"
                                placement="top">
                      <a href="javascript:void(0)"
                         @click="openTableFun(smallIndex)">
                        <img src="@/assets/images/formula/icon-jz.png"
                             alt="">
                      </a>
                    </el-tooltip>
                    <!--<matrix :visible.sync="visibleTable[smallIndex]"
                            @toggleTable="insertMatrix"
                            @delTable="deleteTable" />-->
                  </li>
                </ul>
                <!--<p class="tip abs" style="right:0;top:10px;font-size:14px;">（建议使用键盘ctrl+c/v进行复制/粘贴）</p>-->
              </div>

              <!-- <div class="answerArea"
                    v-html="checkHtml(currentQuestion.smallContent[smallIndex].attAnswer) !== '' ? (checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) !== '' ? checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) : checkHtml(currentQuestion.smallContent[smallIndex].attAnswer)) : checkHtml(currentQuestion.smallContent[smallIndex].userAnswer)"
                    ref="hasChildAnswerArea"
                    id="answerArea"
                    contenteditable="true"
                    @mouseup="mouseUpFn">
               </div>-->

              <!--contenteditable="true"  表格外面是否可编辑-->
              <!--此处两个div代码,除了v-if 以外都是一样的，其实可以删掉一个，-->

              <div
                  :smallIndexFalse="smallIndex"
                  v-if="currentQuestion.smallContent[smallIndex].attAnswer!=='' && currentQuestion.smallContent[smallIndex].attAnswer!==null"
                  class="answerArea"
                  v-html="checkHtml(currentQuestion.smallContent[smallIndex].attAnswer) !== '' ? (checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) !== '' ? checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) : checkHtml(currentQuestion.smallContent[smallIndex].attAnswer)) : checkHtml(currentQuestion.smallContent[smallIndex].userAnswer)"
                  ref="hasChildAnswerArea"
                  id="answerArea"
                  contenteditable="true"
                  @mouseup="mouseUpFn">
              </div>
              <div v-else
                   :smallIndexTrue="smallIndex"
                   class="answerArea"
                   v-html="checkHtml(currentQuestion.smallContent[smallIndex].attAnswer) !== '' ? (checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) !== '' ? checkHtml(currentQuestion.smallContent[smallIndex].userAnswer) : checkHtml(currentQuestion.smallContent[smallIndex].attAnswer)) : checkHtml(currentQuestion.smallContent[smallIndex].userAnswer)"
                   ref="hasChildAnswerArea"
                   id="answerArea"
                   contenteditable="true"
                   @mouseup="mouseUpFn">
              </div>
            </div>
          </div>
          <!--普通卷-->
          <div v-if="$route.query.flag === 'ordinary'">
            <div class="is-show-answers"
                 @click="toggleAnalyse"
                 v-if="isShowAnswer"
                 v-text="isAnswerShowNew === true ? '收起答案解析': '查看答案解析'">
            </div>
            <div class="answer-box"
                 v-if="isAnswerShowNew">
              <strong class="answer-right">正确答案：</strong>
              <span v-html="currentQuestion.smallContent[smallIndex].answer"
                    class="answer-right"></span><br/>
              <template
                  v-if="currentQuestion.smallContent[smallIndex].analysis!=='' && currentQuestion.smallContent[smallIndex].analysis!==null">
                <strong class="answer-ananlysis">答案解析：</strong>
                <span v-html="currentQuestion.smallContent[smallIndex].analysis"></span><br/>
              </template>
              <!--<span class="answer-assessment" v-if="isShowPointAssessment">【该题针对 <span
                class="answer-assessment-name" v-html="'“'+currentQuestion.pointNames+'”'"></span> 进行考核】</span>-->
              <template
                  v-if="isShowVideoExplain && currentQuestion.smallContent[smallIndex].vdeioAddr !== null && currentQuestion.smallContent[smallIndex].vdeioAddr !== ''">
                <strong class="answer-ananlysis">视频解析：</strong>
                <a href="javascript:void(0)"
                   class="video-btn"
                   @click="videoExplain(currentQuestion.smallContent[smallIndex].questionID,currentQuestion.smallContent[smallIndex].pointList)">精讲视频</a>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="sa-input sa-input-simple" ref="saInput" v-else>
        <div class="quesContent quesContent-simple" ref="quesContent">
          <div v-for="(smallContent,index) in currentQuestion.smallContent" :key="index" class="pr">
            <!-- 单选题、判断题 -->
            <template v-if="smallContent.quesTypeID === 1 || smallContent.quesTypeID === 3">
              <exam-single-choice-simple
                  :id="'smallId'+smallContent.newNum"
                  :key="index"
                  :idx="index"
              ></exam-single-choice-simple>
            </template>
            <!-- 多选题 -->
            <template v-if="smallContent.quesTypeID === 2">
              <exam-multiple-choice-simple
                  :id="'smallId'+smallContent.newNum"
                  :key="index"
                  :idx="index"
              ></exam-multiple-choice-simple>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!--矩阵弹框-->
    <dialog-matrix :visible.sync="visibleMatrixTip"></dialog-matrix>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getPlayAuxiliaryUrl} from '@/api'
import Formula from '../formula'
import Matrix from '../matrix'
import editor from '@/mixins/editor'
import '@/utils/moveAndDrag'
import hasChildShortQuestion from '@/mixins/hasChildShortQuestion'
import DialogMatrix from '@/components/exam/DialogMatrix'
// import 'wicked-good-xpath'
import annotator from 'annotator'
import {
  ExamSingleChoiceSimple,
  ExamMultipleChoiceSimple,
} from '@components/exam'

export default {
  name: 'HasChildQuestion',
  components: {
    Formula,
    Matrix,
    DialogMatrix,
    ExamSingleChoiceSimple,
    ExamMultipleChoiceSimple
  },
  computed: {
    ...mapGetters(['currentQuestionIndex', 'currentQuestion']),
    magnifyText() {
      return this.frameStatus ? '恢复' : '放大'
    },
    quesContent() {
      return $.trim(this.currentQuestion.content)
    }
  },
  mixins: [editor, hasChildShortQuestion],
  props: {
    isShowProposal: {
      //是否显示建议
      type: Boolean,
      default: false
    },
    isShowAnswerQuestion: {
      //是否显示答疑
      type: Boolean,
      default: false
    },
    isShowAnswer: {
      //是否显示答案项
      type: Boolean,
      default: false
    },
    isAnswerShow: {
      //是否显示答案
      type: Boolean,
      default: false
    },
    isShowQzSeat: {
      //是否显示题目位置
      type: Boolean,
      default: false
    },
    isShowCollect: {
      //是否显示收藏
      type: Boolean,
      default: false
    },
    isShowPointAssessment: {
      //是否显示知识点考核
      type: Boolean,
      default: false
    },
    isShowVideoExplain: {
      //是否显示视频讲解
      type: Boolean,
      default: false
    },
    faqlUrl: {
      //答疑跳转地址
      type: String
    },
    isShowLeftInfo: {
      type: Boolean,
      default: true
    }

  },
  watch: {
    currentQuestion: {
      handler(newVal, oldVal) {
        if (newVal.content !== oldVal.content) {
          this.smallIndex = 0
        }
      },
      deep: true,
    },
    'currentQuestion.smallContent': {
      handler(newVal) {
        this.setInnerHtml(newVal[this.smallIndex])
        // console.log(this.smallIndex)
      },
      deep: true,
    },
    isAnswerShow() {
      this.isAnswerShowNew = false
    },
    isShowLeftInfo(newVal, oldVal) {
      // debugger;
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.mainWidth = this.$refs.shortAnswer.offsetWidth
          this.getWidth()
          this.setLayout(1)
        }, 1000)
        this.$forceUpdate()
      }
    }

  },
  data() {
    return {
      sortArr: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五'],
      visibleTable: [false, false, false, false, false, false, false, false], // 矩阵显隐
      visibleMatrixTip: false, //矩阵提示弹框显隐
      visibleFm: [false, false, false, false, false, false, false, false], //  公式显隐
      visibleIME: false, //  输入法显隐
      frameStatus: false, //答题区是否缩放了
      westWidth: '50%', //左侧题干区宽度
      westHeight: '50%',
      smallIndex: 0,
      smallIndexQues: 0,//资料题序号
      //容器对象
      rangeData: {
        //  鼠标选中数据
        start: 0,
        end: 0,
        text: '',
      },
      editorContainer: null,
      currentFormulaID: '', //  当前正在编辑的公式span的id
      blankSpan:
          '<span class="blankSpan">&nbsp;</span>',
      formulaHtml:
          '<span id="span_formula_{0}" class="isFormula"></span>',
      matrixHtml: '',
      currentQuestionChange: false,
      isShowLeft: true,
      isShowRight: true,
      mainWidth: '',
      defaultWidth: '', //左侧宽度
      defaultRightWidth: '', //右侧宽度
      addTable: null,
      isAnswerShowNew: this.isAnswerShow,
    }
  },
  mounted() {
    this.mainWidth = this.$refs.shortAnswer.offsetWidth
    this.isAnswerShowNew = false
    this.setLayout(1)
    this.$nextTick(() => {
      var elem = document.querySelector('#quesContentId')
      this.ann = new annotator.App().include(annotator.ui.main, {
        element: elem,
      })
      var elem2 = document.querySelector('#quesContentId2');
      if(elem2){
        this.ann2 = new annotator.App().include(annotator.ui.main, {element: elem2})
        this.ann2.start();
      }
      this.ann.start()
    })
    // eslint-disable-next-line no-undef
    this.addTable = addTable('.answerArea', '')

    $('body').keydown(function (event) {
      if (event.keyCode == 8) {
        // event.preventDefault()
      }
    })
  },
  methods: {
    /* handelData(text){
       let textCopy = text;
       let link=$('<div class="str_div"></div>');
       link.html(textCopy);
       $(link).find('table td').each(function(){
         var self=$(this);
         if(self.text().trim()==""){
           self.attr('contenteditable','true');
           self.css('background-color','transparent');
         }else{
           self.attr('contenteditable','false');
           self.css('background-color','#eeeeee');
         }
       })
       text = $(link).html();
     },*/
    checkHtml(text) {
      /*let textCopy = text;
      let link=$('<div class="str_div"></div>');
      link.html(textCopy);
      $(link).find('table td').each(function(){
        var self=$(this);
        if(self.text().trim()==""){
          self.attr('contenteditable','true');
          self.css('background-color','transparent');
        }else{
          self.attr('contenteditable','false');
          self.css('background-color','#eeeeee');
        }
      })
      text = $(link).html();*/

      return text === null || text === 'null' || text === '<br/>' || text === '<br>' ? '' : text
    },
    //分栏设置
    setLayout(quesTag) {
      if (quesTag == 1) {
        //上下分栏
        var myLayout = $('#shortAnswer').layout({
          resizable: true,
          livePaneResizing: true,
          applyDemoStyles: true,
          // west__closable: false,
          north__closable: false,
          north__minSize: '10%',
          north__maxSize: '90%',
          //调整大小时调用的函数
          // onresize_end: this.changeFck(),
        })

        // myLayout.sizePane('north', '20%')
        myLayout.sizePane('north', this.westHeight)
        // myLayout.resizeAll()
      } else if (quesTag == 2) {
        // $(window).trigger('resize')
        //左右分栏
        myLayout = $('#shortAnswer').layout({
          resizable: true,
          livePaneResizing: true,//拖拽时缩放
          resizerTip: '可调整大小', //鼠标移到边框时，提示语
          applyDemoStyles: true,
          west__closable: false,
          west__minSize: '9%',
          west__maxSize: '91%',
        })
        myLayout.sizePane('west', this.westWidth)
      }
    },
    //缩放答题区大小
    toggleWin(val) {
      if (!this.frameStatus) {
        if (val == 'top') {
          this.westHeight = '95%'
          this.isShowLeft = true
          this.isShowRight = false
        } else {
          this.westHeight = '5%'
          this.isShowLeft = false
          this.isShowRight = true
        }
        this.setLayout(1)
        this.frameStatus = true
        this.$forceUpdate()
      } else {
        this.westHeight = '50%'
        this.isShowLeft = true
        this.isShowRight = true
        this.setLayout(1)
        this.frameStatus = false
      }
    },
    getWidth() {
      this.$nextTick(() => {
        if (this.$refs.defaultWidth) {
          this.defaultWidth = this.$refs.defaultWidth.offsetWidth
          const percent = Number(this.defaultWidth / this.mainWidth)
          if (percent <= 0.091) {
            this.isShowLeft = false
          } else {
            this.isShowLeft = true
          }
          this.$forceUpdate()
        }
        if (this.$refs.rightChildQuestion) {
          this.defaultRightWidth = this.$refs.defaultWidth.offsetWidth
          const percent = Number(this.defaultWidth / this.mainWidth)
          if (percent >= 0.90) {
            this.isShowRight = false
          } else {
            this.isShowRight = true
          }
          this.$forceUpdate()
        }
      })
    },
    resize() {
      $(window).trigger('resize')
    },
    resizeWest() {
      this.getWidth()
    },
    toggleAnalyse() {
      this.isAnswerShowNew = !this.isAnswerShowNew
    },
    //视频讲解
    videoExplain(questionID, pointList) {
      let pointIDArr = [], pointIDStr = ''
      for (let i in pointList) {
        if (pointList[i] && pointList[i].pointID) {
          pointIDArr.push(pointList[i].pointID)
        }
      }
      pointIDStr = pointIDArr.join(',')
      let params = {
        questionId: String(questionID),
        pointList: pointIDStr
      }
      getPlayAuxiliaryUrl(params).then(res => {
        window.open(res.playUrl, '_blank')
      })
    },

    //资料题目内容切换
    anchorClick(e, index) {
      let _dom = e.target
      if (_dom.className.indexOf('actived') < 0) {
        this.smallIndexQues = index
      }
    },
  },
  destroyed() {
    this.ann.destroy()
    if(this.ann2){
      this.ann2.destroy();
    }
  }
}
</script>
<style lang="scss">
.annotator-hl {
  text-decoration: underline;
}

.ui-layout-resizer {
  width: 100% !important;
}
</style>
<style lang="scss" scoped>
$imgUrl: '~@/assets/images/doExam/';
.short-answer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  line-height: 1.6;

/*  .ui-layout-north{
    //height: 50% !important;
!*    width: 100% !important;
    top: 0 !important;
    overflow: auto !important;*!
  }
  .ui-layout-center {
    //height: 50% !important;
!*    width: 100% !important;
    top: 50% !important;
    overflow: auto !important;
    left: 0 !important;*!
    //border-top: 6px solid #dddddd !important;
  }*/

  .ui-layout-north,
  .ui-layout-center {
    overflow: hidden !important;
    width: 100% !important;
  }

  .border0 {
    border: none !important;
  }

  .padding0 {
    padding: 0 !important;
  }

  .item-title {
    height: 100%;

    .item-head-title {
      width: 100%;
      padding: 16px;

      .pull-right {
        float: right;

        .min-btn {
          border-radius: 4px;
          border: 1px solid #ddd;
          font-size: 14px;
          padding: 0 7px;
          color: #666;
          display: inline-block;
          box-sizing: border-box;
          line-height: 26px;
          background: #fff;

          i {
            display: inline-block;
            width: 15px;
            height: 7px;
            background: url($imgUrl + 'icon-sf.png') left center no-repeat;
            margin-right: 5px;
          }
        }
      }
    }

    .item-ques {
      width: 98%;
      height: calc(100% - 60px);
      position: absolute;
      left: 20px;
      top: 60px;
      display: flex;
      flex-direction: column;

      .anchor-list {
        margin: 15px 0;
        border-bottom: 1px solid #dee2e6;

        li {
          cursor: pointer;
          display: inline-block;
          padding: 0 5px;
          border: 1px solid #ddd;
          margin: 0 0 -1px 0px;
          border-radius: 4px 4px 0 0;

          &.actived {
            background-color: #447dff;
            color: #fff;
          }
        }
      }
      #quesContentId {
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        &.has-requestList {
          flex: unset;
          overflow: unset;
          overflow-y: unset;
        }
      }
      #quesContentId2 {
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
      }
    }
  }

  .content-stem {
    line-height: 1.6;
    color: #000000;
    width: 100%;
    margin-bottom: 10px;
    font-weight: bold;

    .ques-num {
      display: inline-block;
      padding: 0 5px;
      background-color: #447dff;
      color: #fff;
      font-style: normal;
      border-radius: 3px;
      min-width: 25px;
      text-align: center;
      margin-right: 10px;
    }
  }

  .sa-function {
    background: #f0f0f0;
    padding: 3px 8px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid #ddd;
    border-bottom: none;
    position: relative;

    ul {
      margin-left: 8px;
      overflow: hidden;
      height: 34px;

      li {
        display: inline-block;
        width: 30px;
        border: 1px solid transparent;
        text-align: center;
        line-height: 30px;
        margin-right: 8px;

        a {
          display: inline-block;
          width: 30px;

          &:hover {
            background-color: #ddd;
            border: 1px solid #ccc;
          }

          img {
            position: relative;
            top: 5px;
          }
        }
      }
    }

    .count-num {
      top: 0;
      right: 8px;
      line-height: 41px;
    }
  }

  .sa-input {
    width: 100%;
    height:calc(100% - 60px);
    padding: 10px 16px;
    position: absolute;
    top: 60px;
    left: 0;
    padding-right: 0;
  


    .tab {
      border-bottom: 1px solid #dee2e6 !important;
      margin-right: 10px;

      > span {
        padding: 4px 8px;
        margin: 5px 0 -1px -1px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-top: 1px solid #ddd;
        font-size: 16px;
        cursor: pointer;

        &.actived {
          background-color: #447dff;
          color: #fff;
        }
      }
    }

    .clearfix {
      height: 100%;
      display: flex;
      flex-direction: column;
  
      .quesContent {
        // max-height: calc(100% - 95px);
        display: flex;
        flex-direction: column;
        flex:1;
        overflow: hidden;
        overflow-y: auto;
        padding-right: 10px;
        .editor{
            display: flex;
            flex-direction: column;
            flex:1;
            min-height: 0;
            .sa-function{
              height: auto;
            }
            .answerArea{
              flex:1;
              margin-bottom: 0;
              overflow: auto;
            }
        }
      }
    }

    .sa-title {
      line-height: 1.6;
      margin: 16px 0 10px 0;

      .smallNum {
        display: inline-block;
        padding: 0 5px;
        background-color: #447dff;
        color: #fff;
        font-style: normal;
        border-radius: 3px;
        min-width: 25px;
        text-align: center;
        margin-right: 10px;
      }
    }

    .answerArea {
      border: 1px solid #ddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 5px;
      outline: 0;
      overflow: auto;
      background-color: #fafafa;
      min-height: 160px;
      max-height: 500px;
      overflow-y: auto;
      margin-bottom: 25px;
      word-wrap: break-word;
    }
  }

  .sa-input-simple {
    padding: 0;
  }

  .formulaDiv {
    position: absolute;
    left: 114px;
    top: 38px;
    display: none;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);

    .tabMenu {
      border: none !important;
    }
  }

  //
  .is-show-answers {
    width: 136px;
    height: 34px;
    line-height: 34px;
    color: #437eff;
    font-size: 16px;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid #1e74e1;
    text-align: center;
    margin-top: 15px;
  }

  .answer-box {
    margin-bottom: 5px;
    padding: 20px;
    font-size: 14px;
    color: #474747;
    line-height: 31px;
    margin-top: 10px;
    background: #f9f9fa;

    .answer-right {
      color: #56db9a;
      font-weight: bold;
    }

    .video-btn {
      color: #437eff;
    }
  }
}
</style>
